import usePulseScope from '@/shared/components/PulseScope/usePulseScope'
import type { SentBoxProps } from '../types'
import { StyledBadge, StyledSentBadge, StyledSentBox, StyledSentTitle } from '../styled-components'

const SentBox = ({ hidden, title, sentAt, badge, badgeHidden }: SentBoxProps) => {
  const isPulse = usePulseScope()

  if (hidden) {
    return null
  }

  return (
    <StyledSentBox $pulse={isPulse}>
      <StyledSentTitle $pulse={isPulse}>{title}</StyledSentTitle> · {sentAt}
      <StyledSentBadge hidden={badgeHidden}>
        <StyledBadge $pulse={isPulse}>{badge}</StyledBadge>
      </StyledSentBadge>
    </StyledSentBox>
  )
}

export default SentBox
